///operator/audio/pre-recorded

import apiCall from "../../axios";
import queryString from "query-string";

const preRecordedAudio = async (payload: any) => {
  try {
    const res = await apiCall("POST", `operator/audio/pre-recorded`, payload);
    return res.data;
  } catch (e) {
    if (e) return e;
    return { error: "Unknown Error" };
  }
};

export default preRecordedAudio;
